export default Object.freeze({
  BRIGHTNESS_OFFSET: 'BRIGHTNESS_OFFSET',
  SHADE: 'SHADE',
  SHADE_OFFSET: 'SHADE_OFFSET'
});